<div class="col-12 text-center" style="padding: 22px;margin: -16px -16px 8px;">
	<a routerLink="/ami-staff-performance" [queryParams]="{week: week, year: year}" routerLinkActive="active">Staff Performance</a>
	/
	<a routerLink="/studio-business-summary" [queryParams]="{week: week, year: year}" routerLinkActive="active">Studio Business</a>
	/
	<a routerLink="/royalty-report" [queryParams]="{week: week, year: year}" routerLinkActive="active">Royalty Report</a>
	/
	<a routerLink="/miscellaneous-report" [queryParams]="{week: week, year: year}" routerLinkActive="active">Miscellaneous Report</a>
</div>
